import { render, staticRenderFns } from "./instrument.vue?vue&type=template&id=6f64d7c6&scoped=true"
import script from "./instrument.vue?vue&type=script&lang=js"
export * from "./instrument.vue?vue&type=script&lang=js"
import style0 from "./instrument.vue?vue&type=style&index=0&id=6f64d7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64d7c6",
  null
  
)

export default component.exports